import { useEffect } from 'react';
import { SITE } from '../data';

// Sets a unique <title> and meta description for each page.
export default function usePageMeta(title, description) {
  useEffect(() => {
    document.title = title ? `${title} | ${SITE.name}` : `${SITE.name} | Web, Mobile, Design & Animation Agency`;
    let tag = document.querySelector('meta[name="description"]');
    if (!tag) {
      tag = document.createElement('meta');
      tag.name = 'description';
      document.head.appendChild(tag);
    }
    if (description) tag.setAttribute('content', description);
  }, [title, description]);
}
